export const messages = Object.freeze({
    cid_is_none: 'A required value is missing. Refresh the page and try again.',
    column_missing: 'The column is missing or could not be found.',
    gunzip_not_a_file: 'The selected item is not a valid archive file.',
    missing_access_token: 'Required access token is missing.',
    missing_rsa_key: 'The operation could not be completed. Please try again or contact support.',
    missing_snowflake_query_id: 'Required Tables query ID is missing.',
    missing_unload_secret: 'A required configuration is unavailable. Please contact support.',
    no_query_statement: 'No query statement was found or provided.',
    no_snowflake_account: 'No Tables account was found or provided.',
    qid_is_none: 'A required value is missing. Refresh the page and try again.',
    query_already_submitted: 'The query is already submitted.',
    query_missing: 'The query is missing or could not be found.',
    query_not_running: 'The query is not running.',
    query_not_select: 'The query is not select.',
    query_still_running: 'The query is currently running. Please try again later.',
    query_terminated: 'The query was terminated.',
    short_id_is_none: 'A required short ID value is missing from the request.',
    snid_is_none: 'A required snapshot value is missing from the request.',
    table_deleted: 'The table has been deleted.',
    table_missing: 'The table is missing or could not be found.',
    tid_is_none: 'A required table value is missing from the request.',
    unidentifiable_query_request: 'The request could not be processed because a required identifier is missing.'
})

export const dialogs = Object.freeze({})
